import {DateTimePicker, DateTimePickerProps} from "@progress/kendo-react-dateinputs";
import {FlintValidationData} from "@utils/AppConstants";
import {Error} from "@progress/kendo-react-labels";

export default function FlintDateTimePicker(props: flintDateTimePickerProps) {
    const handleBlur = (event: React.FocusEvent<HTMLDivElement | HTMLSpanElement, Element>) => {
        validationData?.validateFunction?.(validationData?.optionalObjectToValidate).catch((err) => {});
        if (props.onBlur) {
            props.onBlur(event); // Call the parent's onBlur handler if provided
        }
    };

    const {format = "yyyy-MM-dd HH:mm", validationData, ...other} = props;
    return (<div className={"flint-date-time-picker"}>
        <DateTimePicker
            format={format}
            valid={!validationData?.validationMessage}
            onBlur={handleBlur}
            {...other} />
        {validationData?.validationMessage != null && <Error>{validationData.validationMessage}</Error>}
    </div>)
}

export interface flintDateTimePickerProps extends DateTimePickerProps {
    validationData?: FlintValidationData
}